import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import App from './App';
import { register } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Register service worker after React mount.
// On update, dispatch CustomEvent that UpdateToast listens for.
register((registration) => {
  window.dispatchEvent(new CustomEvent('swUpdate', { detail: { registration } }));
});
